import type { FilterDefinition, FilterHandler } from '../engine/types';
import { FilterId, FilterType, type FreeTextFilter } from '../types/filters';

export const keywordsDefinition: FilterDefinition<FreeTextFilter> = {
  id: FilterId.KEYWORDS,
  name: 'Keywords',
  text: [],
  type: FilterType.FREE_TEXT,
  isVisible: true,
};

export const keywordsHandler: FilterHandler<FreeTextFilter> = {
  isActive(currentFilterState: FreeTextFilter) {
    return currentFilterState.text.length > 0;
  },
  isDefault(
    currentFilterState: FreeTextFilter,
    definition: FilterDefinition<FreeTextFilter>
  ) {
    return currentFilterState.text.length === definition.text.length;
  },
  getEffectiveFilter(currentFilterState: FreeTextFilter) {
    return { ...currentFilterState };
  },
};
